/** Shared tool label used by UI and analytics mapping. */
export const BRADLEY_ANALYSE_DATA_TOOL_LABEL = 'Analyze dss+ 360 Data'

/**
 * Amplitude event names — Bradley MVP (EE / product spec).
 * Event strings use snake_case (same convention as `trackEvent` in analytics.composable.js).
 */
export const BRADLEY_ANALYTICS_EVENTS = {
  ASK_BRADLEY_AI_BUTTON: 'ask_bradley_ai_button',
  SEND_PROMPT: 'send_prompt',
  SEND_PROMPT_CLICKED: 'send_prompt_clicked',
  SEND_PROMPT_BLOCKED_NO_TEXT: 'send_prompt_blocked_no_text',
  TYPE_PROMPT: 'type_prompt',
  SELECT_FILES: 'select_files',
  ADD_FILE_CLICKED: 'add_file_clicked',
  UPLOAD_FILE: 'upload_file',
  REMOVE_FILE: 'remove_file',
  FILE_REMOVED: 'file_removed',
  DRAG_AND_DROP_FILE: 'drag_and_drop_file',
  FILE_DRAG_AND_DROP: 'file_drag_and_drop',
  UPLOADING_FILE: 'uploading_file',
  FILE_UPLOAD_STARTED: 'file_upload_started',
  UPLOAD_FILE_SUCCESS: 'upload_file_success',
  FILE_UPLOAD_SUCCESS: 'file_upload_success',
  UPLOAD_FILE_FAIL: 'upload_file_fail',
  FILE_UPLOAD_FAILED: 'file_upload_failed',
  SELECT_TOOLS: 'select_tools',
  REMOVE_TOOLS: 'remove_tools',
  MENU_OPENED: 'menu_opened',
  MENU_TOGGLED: 'menu_toggled',
  EXPAND_MENU: 'expand_menu',
  NEW_CHAT: 'new_chat',
  SEARCH_CHATS: 'search_chats',
  SETTINGS: 'settings',
  UPDATE_SETTINGS: 'update_settings',
  CANCEL: 'cancel',
  CLOSE_BUTTON: 'close_button',
  FAQ: 'faq',
  FAQ_CLOSE: 'close',
  VIEW_QUESTION_1: 'view_question_1',
  VIEW_QUESTION_2: 'view_question_2',
  VIEW_QUESTION_3: 'view_question_3',
  VIEW_QUESTION_4: 'view_question_4',
  VIEW_QUESTION_5: 'view_question_5',
  VIEW_QUESTION_6: 'view_question_6',
  RECENT_CHAT_CLICKED: 'recent_chat_clicked',
  CHAT_RENAME_INITIATED: 'chat_rename_initiated',
  CHAT_RENAMED: 'chat_renamed',
  CHAT_DELETE_INITIATED: 'chat_delete_initiated',
  CHAT_DELETE_CONFIRMED: 'chat_delete_confirmed',
  CHAT_DELETE_CANCELED: 'chat_delete_canceled',
  ICEBREAKER_CLICKED: 'icebreaker_clicked',
  ICEBREAKER_IMPRESSION: 'icebreaker_impression',
  SOURCES_MODAL_OPENED: 'sources_modal_opened',
  SOURCES_MODAL_CLOSED: 'sources_modal_closed',
  SOURCE_LINK_CLICKED: 'source_link_clicked',
  SOURCE_BADGE_CLICKED: 'source_badge_clicked',
  PROJECTS_MENU_CLICK: 'bd_projects_menu_click',
  PROJECTS_LIST_VIEW: 'bd_projects_list_view',
  PROJECTS_LIST_SCROLL: 'bd_projects_list_scroll',
  PROJECT_ITEM_CLICK: 'bd_project_item_click',
  CREATE_PROJECT_BUTTON_CLICK: 'bd_create_project_button_click',
  PROJECT_CREATED: 'bd_project_created',
  PROJECT_NAME_EDIT_STARTED: 'bd_project_name_edit_started',
  PROJECT_NAME_EDIT_CONFIRMED: 'bd_project_name_edit_confirmed',
  PROJECT_NAME_EDIT_CANCELLED: 'bd_project_name_edit_cancelled',
  PROJECT_ACTIONS_MENU_OPENED: 'bd_project_actions_menu_opened',
  PROJECT_RENAME_OPTION_CLICK: 'bd_project_rename_option_click',
  PROJECT_ARCHIVE_OPTION_CLICK: 'bd_project_archive_option_click',
  PROJECT_ARCHIVE_FIRST_CONFIRMATION_VIEW: 'bd_project_archive_first_confirmation_view',
  PROJECT_ARCHIVE_FIRST_CONFIRMATION_CONFIRMED: 'bd_project_archive_first_confirmation_confirmed',
  PROJECT_ARCHIVE_SECOND_CONFIRMATION_VIEW: 'bd_project_archive_second_confirmation_view',
  PROJECT_ARCHIVE_SECOND_CONFIRMATION_CONFIRMED: 'bd_project_archive_second_confirmation_confirmed',
  PROJECT_ARCHIVE_CANCELLED: 'bd_project_archive_cancelled',
  PROJECT_ARCHIVED: 'bd_project_archived',
  PROJECT_WORKSPACE_VIEW: 'bd_project_workspace_view',
  PROJECT_TAB_CLICK: 'bd_project_tab_click',
  PROJECT_BACK_BUTTON_CLICK: 'bd_project_back_button_click',
  PROJECT_CHATS_TAB_VIEW: 'bd_project_chats_tab_view',
  PROJECT_FILES_TAB_VIEW: 'bd_project_files_tab_view',
  PROJECT_AI_OUTPUTS_TAB_VIEW: 'bd_project_ai_outputs_tab_view',
  PROJECT_CHAT_CREATED: 'bd_project_chat_created',
  PROJECT_CHAT_OPENED: 'bd_project_chat_opened',
  PROJECT_CHAT_ACTIONS_MENU_OPENED: 'bd_project_chat_actions_menu_opened',
  PROJECT_CHAT_RENAME_OPTION_CLICK: 'bd_project_chat_rename_option_click',
  PROJECT_CHAT_RENAME_CONFIRMED: 'bd_project_chat_rename_confirmed',
  PROJECT_CHAT_DELETE_OPTION_CLICK: 'bd_project_chat_delete_option_click',
  PROJECT_CHAT_DELETE_FIRST_CONFIRMATION_VIEW: 'bd_project_chat_delete_first_confirmation_view',
  PROJECT_CHAT_DELETE_SECOND_CONFIRMATION_VIEW: 'bd_project_chat_delete_second_confirmation_view',
  PROJECT_CHAT_DELETE_CANCELLED: 'bd_project_chat_delete_cancelled',
  PROJECT_CHAT_DELETED: 'bd_project_chat_deleted',
  PROJECT_FILE_UPLOADED: 'bd_project_file_uploaded',
  PROJECT_FILE_DOWNLOAD_CLICK: 'bd_project_file_download_click',
  PROJECT_FILE_ACTIONS_MENU_OPENED: 'bd_project_file_actions_menu_opened',
  PROJECT_FILE_RENAME_STARTED: 'bd_project_file_rename_started',
  PROJECT_FILE_RENAME_CONFIRMED: 'bd_project_file_rename_confirmed',
  PROJECT_FILE_DELETE_OPTION_CLICK: 'bd_project_file_delete_option_click',
  PROJECT_FILE_DELETE_FIRST_CONFIRMATION_VIEW: 'bd_project_file_delete_first_confirmation_view',
  PROJECT_FILE_DELETE_SECOND_CONFIRMATION_VIEW: 'bd_project_file_delete_second_confirmation_view',
  PROJECT_FILE_DELETE_CANCELLED: 'bd_project_file_delete_cancelled',
  PROJECT_FILE_DELETED: 'bd_project_file_deleted',
  PROJECT_FILE_REUSED_IN_PROMPT: 'bd_project_file_reused_in_prompt',
  PROJECT_FILES_LIST_SCROLL: 'bd_project_files_list_scroll',
  PROJECT_PROMPT_SUBMITTED: 'bd_project_prompt_submitted',
  PROJECT_PROMPT_FILE_ATTACHED: 'bd_project_prompt_file_attached',
  PROJECT_PROMPT_TOOL_BUTTON_CLICK: 'bd_project_prompt_tool_button_click',
  PROJECT_PROMPT_TOOL_SELECTED: 'bd_project_prompt_tool_selected',
  PROJECT_RESPONSE_GENERATED: 'bd_project_response_generated',
  PROJECT_RESPONSE_COPY_CLICK: 'bd_project_response_copy_click',
  PROJECT_RESPONSE_FEEDBACK_POSITIVE: 'bd_project_response_feedback_positive',
  PROJECT_RESPONSE_FEEDBACK_NEGATIVE: 'bd_project_response_feedback_negative',
}

export const BRADLEY_PROJECT_WORKSPACE_TABS = {
  CHATS: 'chats',
  FILES: 'files',
  AI_OUTPUTS: 'ai_outputs',
}

export const BRADLEY_PROJECT_TAB_VIEW_EVENTS = {
  [BRADLEY_PROJECT_WORKSPACE_TABS.CHATS]: BRADLEY_ANALYTICS_EVENTS.PROJECT_CHATS_TAB_VIEW,
  [BRADLEY_PROJECT_WORKSPACE_TABS.FILES]: BRADLEY_ANALYTICS_EVENTS.PROJECT_FILES_TAB_VIEW,
  [BRADLEY_PROJECT_WORKSPACE_TABS.AI_OUTPUTS]: BRADLEY_ANALYTICS_EVENTS.PROJECT_AI_OUTPUTS_TAB_VIEW,
}

export const BRADLEY_ICEBREAKER_IDS = [
  'prompt1',
  'prompt2',
  'prompt3',
  'prompt4',
]

export const BRADLEY_ICEBREAKER_COUNT = BRADLEY_ICEBREAKER_IDS.length

/** Maps FAQ accordion section id (`1`–`6`) to Amplitude view events. */
export const BRADLEY_FAQ_VIEW_QUESTION_BY_SECTION = {
  1: BRADLEY_ANALYTICS_EVENTS.VIEW_QUESTION_1,
  2: BRADLEY_ANALYTICS_EVENTS.VIEW_QUESTION_2,
  3: BRADLEY_ANALYTICS_EVENTS.VIEW_QUESTION_3,
  4: BRADLEY_ANALYTICS_EVENTS.VIEW_QUESTION_4,
  5: BRADLEY_ANALYTICS_EVENTS.VIEW_QUESTION_5,
  6: BRADLEY_ANALYTICS_EVENTS.VIEW_QUESTION_6,
}
